// extracted by mini-css-extract-plugin
export default {"addressAction":"h6-z","loading":"i6-z"};